// ======================================================================
// File Name       : SessionStorageUtils
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as Utils from './index';
import { USER_QUERY } from '../constants/SessionStorageConstants';
import { CONTENT_TYPE_NAME_LIST } from '../constants/ContentConstant';

const INIT_QUERY_INFO = {
  hideTopMenu: false,
  showContentsOnly: '',
  queryString: '',
};

export function getByKey(key) {
  return sessionStorage.getItem(key);
}

export function save(key, value) {
  sessionStorage.setItem(key, value);
}

export function clear() {
  sessionStorage.clear();
}

/**
 * Get query info from Session Storage,
 * return INIT_QUERY_INFO as default
 */
export function getUserQuery() {
  const queryInfo = getByKey(USER_QUERY);
  return queryInfo ? JSON.parse(queryInfo) : INIT_QUERY_INFO;
}

export function isHideBackBtn() {
  const { hideTopMenu } = getUserQuery();
  return hideTopMenu;
}

/**
 * Get query param and store to Session Storage
 */
export function storeUserQuery(location) {
  if (!location.search) {
    return getUserQuery();
  }

  const queryParam = Utils.getQueryParam(location);
  const { hideTopMenu, showContentsOnly } = queryParam;
  queryParam.hideTopMenu = hideTopMenu === 'true';
  queryParam.showContentsOnly =
    showContentsOnly && CONTENT_TYPE_NAME_LIST.indexOf(showContentsOnly) > -1
      ? showContentsOnly
      : '';

  const queryInfo = {
    ...INIT_QUERY_INFO,
    ...queryParam,
  };

  save(USER_QUERY, JSON.stringify(queryInfo));

  return queryInfo;
}

export function setLoginType(val) {
  save('loginType', val);
}

export function getLoginType() {
  return getByKey('loginType');
}
